import Img1 from "../images/download/appstore.svg";
import Img2 from "../images/download/googleapp.svg";

function Download() {
  return (
    <>
      <section className="download-section">
        <div className="container">
          <div className="download-text">
            <h2>Téléchargez bientôt notre application pour en profiter au maximum</h2>
              <p>
                Accédez à une expérience encore plus simple et pratique grâce à notre
                application mobile. Gérez vos réservations, retrouvez vos informations en un
                clin d'œil et profitez de fonctionnalités dédiées pour faciliter chacun de vos
                déplacements.
              </p>
            <div className="download-text__btns">
              <img alt="download_img" src={Img2} />
              <img alt="download_img" src={Img1} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Download;
